import Common from '../common'
var Js = Common('cardInfo')
export default {
	name: 'cardInfo',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'product_no',
					label: '商品NO',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 100
				},
				{
					key: 'card_no',
					label: '卡号',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入卡号',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.card_no = val;
							} else {
								delete self.searchItem.card_no;
							};

						},
					},
				},
				{
					key: 'description',
					label: '激活码',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'price',
					label: '价值',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: "active_status",
					label: '激活状态',
					application: ['编辑'],
					listType: 'normal',
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.active_status == 1) {
							return '已激活';
						} else {
							return '未激活';
						};
					},
					header_search: {
						componentName: 'sls-select',
						optionsName: 'statusOptions',
						placeholder: '请选择是否激活',
						changeFunc: function(val, self) {
							if (val || val === 0) {
								self.searchItem.active_status = val;
							} else {
								delete self.searchItem.active_status;
							};

						},
					},
					width: 120
				},
				{
					key: "use_status",
					label: '使用状态',
					application: ['编辑'],
					listType: 'normal',
					componentName: 'sls-select',
					optionsName: 'useOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.use_status == 1) {
							return '已使用';
						} else {
							return '未使用';
						};
					},
					header_search: {
						componentName: 'sls-select',
						optionsName: 'useOptions',
						placeholder: '请选择是否使用',
						changeFunc: function(val, self) {
							if (val || val === 0) {
								self.searchItem.use_status = val;
							} else {
								delete self.searchItem.use_status;
							};

						},
					},
					width: 120
				},
				{
					key: 'relation_two',
					label: '持卡用户',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					formatter: function(val) {
						return val.user.nickname
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 80
				},
			],
			// 按钮配置
			btn_info: [{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_relationUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_relationUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_relationAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								content: '',
								price: '',
								mainImg: [],
								bannerImg: [],
								img_array: []
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 3;
							self.submitData.category_id = 18;
							var postData = {
								data: self.submitData
							};
							console.log(postData)

							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					funcType: 'func',
					position: 'header',
					text: function(data) {
						return '导入提货卡'
					},
					func: {
						func: function(self) {
							self.uploadClick()
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
									user_type: 1
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '恢复数据'
					},
					func: {
						apiName: function(self) {
							return "api_relationUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									status: -1
								},
								data: {
									status: 1
								}
							};
							return postData;
						}
					},
				},
			],

			searchItem: {
				status: 1
			},
			startSearchItem: {
				status: 1
			},
			optionData: {
				labelOptions: [],
				skuOptions: [],
				statusOptions: [{
					text: '已激活',
					value: 1
				}, {
					text: '未激活',
					value: 0
				}],
				useOptions: [{
					text: '已使用',
					value: 1
				}, {
					text: '未使用',
					value: 0
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},

	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			// this.initLabelData();
		},

		async initLabelData(isNew) {

			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				status: -1
			};
			postData.data = {
				status: 1
			}
			var res = await self.$$api_relationUpdate({
				data: postData
			});
		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				user: {
					tableName: 'User',
					middleKey: 'relation_two',
					key: 'user_no',
					condition: '=',
					info: ['nickname']
				}
			}

			var res = await self.$$api_relationGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		},

		uploadClick() {
			const self = this;
			self.$refs.uploadInput.click();
		},

		async upload(e) {

			const self = this;
			let file = e.target.files[0];
			var obj = file.name.lastIndexOf(".");
			var ext = file.name.substr(obj + 1);
			let param = new FormData() // 创建form对象

			param.append('excel', file, file.name) // 通过append向form对象添加数据
			param.append('excelChangeKey', JSON.stringify({
				'卡号': 'card_no',
				'激活码': 'description',
				'价值': 'price'
			}));
			param.append('token', self.$store.getters.getToken);
			param.append('ext', ext);
			param.append('md5', 'md5');

			param.append('totalSize', file.size);
			param.append('start', 0);
			param.append('chunkSize', file.size);
			param.append('originName', file.name);
			// POST表单数据
			//param.append('chunk', '0') // 添加form表单中其他数据
			//console.log(param.get('file'))  FormData私有类对象，访问不到，可以通过get判断值是否传进去
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
			//console.log(param.get('file'));
			try {
				var res = await self.$$api_relationAdd({
					data: param,
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				if (res.solely_code == 100000) {
					self.$$notify('导入成功', 'fail');
					this.initMainData();
				} else {
					self.$$notify(res.msg, 'fail');
				};
				self.$refs.uploadInput.value = '';
			} catch (e) {
				self.$refs.uploadInput.value = '';
			}

		},

	},


}



// WEBPACK FOOTER //
// ./src/views/product/cardInfo.js